import { useContext } from "react";
import { WfFormRendererContext, WfFormRendererContextProvider } from "../contexts/WfFormRendererContext";

export function useWfFormRendererContext() {
  const context = useContext(WfFormRendererContext);
  if (!context) {
    throw new Error(`${useWfFormRendererContext.name} must be used within a ${WfFormRendererContextProvider.name}`);
  }
  return context;
}